import { useState, useRef, useEffect } from 'react';
import { usePreferences } from '../../hooks/usePreferences.jsx';

// Deve coincidir com CHAT_MESSAGE_MAX_LENGTH em backend/routes/chat.py.
const CHAT_MESSAGE_MAX_LENGTH = 4000;

const FONT_CLASSES = {
  'P': 'text-sm',
  'M': 'text-base',
  'G': 'text-lg',
};

export const ChatInput = ({ onSendMessage, onStop, disabled, sinodoMode = false }) => {
  const [input, setInput] = useState('');
  const textareaRef = useRef(null);
  const { preferences } = usePreferences();

  useEffect(() => {
    const ta = textareaRef.current;
    if (!ta) return;
    ta.style.height = 'auto';
    ta.style.height = `${Math.min(ta.scrollHeight, 200)}px`;
  }, [input]);

  const handleSend = () => {
    if (input.trim() && !disabled) {
      onSendMessage(input.trim());
      setInput('');
      if (textareaRef.current) {
        textareaRef.current.style.height = 'auto';
      }
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="max-w-3xl mx-auto">
      <div className={`glass-panel ghost-border-tl rounded-2xl p-3 flex items-end gap-2 shadow-[0px_16px_32px_rgba(5,7,10,0.6)] ${sinodoMode ? 'ring-2 ring-primary/50' : ''}`}>
        <textarea
          ref={textareaRef}
          rows={1}
          maxLength={CHAT_MESSAGE_MAX_LENGTH}
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={sinodoMode ? 'Pergunte ao Sínodo Virtual...' : 'Busque a sabedoria aqui...'}
          disabled={disabled}
          className={`flex-1 bg-transparent border-none text-on-surface placeholder:text-on-surface-variant/40 font-body ${FONT_CLASSES[preferences.fontSize] || 'text-base'} focus:ring-0 focus:outline-none px-2 py-1 resize-none overflow-hidden leading-relaxed`}
          style={{ minHeight: '36px' }}
        />
        <button
          onClick={disabled ? onStop : handleSend}
          disabled={!disabled && !input.trim()}
          title={disabled ? 'Parar resposta' : 'Enviar'}
          className="bg-primary text-on-primary w-10 h-10 rounded-full flex-shrink-0 flex items-center justify-center hover:bg-primary-fixed transition-all duration-300 shadow-[0_0_15px_rgba(242,202,80,0.2)] divine-glow-hover disabled:opacity-50 mb-0.5"
        >
          <span className="material-symbols-outlined text-[20px] ml-0.5" style={{ fontVariationSettings: "'FILL' 1" }}>
            {disabled ? 'stop' : 'send'}
          </span>
        </button>
      </div>
      <div className="text-center mt-2">
        {input.length > CHAT_MESSAGE_MAX_LENGTH * 0.9 && (
          <p className="font-body text-xs text-on-surface-variant/60 mb-1" aria-live="polite">
            {input.length}/{CHAT_MESSAGE_MAX_LENGTH} caracteres
          </p>
        )}
        <p className="font-body text-xs text-on-surface-variant/40 font-light">
          {sinodoMode
            ? 'Modo Sínodo Virtual ativo — sua próxima mensagem custará 2 créditos.'
            : (
              <>
                <span className="hidden md:inline">Enter para enviar · Shift+Enter para nova linha · </span>
                Respostas geradas por IA, podem conter erros — não substituem orientação sacerdotal.
              </>
            )}
        </p>
      </div>
    </div>
  );
};
